import { identity } from "@thi.ng/api/fn";
import { toPath } from "./path.js";
const defGetterUnsafe = (path) => defGetter(path);
function defGetter(path) {
  const ks = toPath(path);
  const [a, b, c, d] = ks;
  switch (ks.length) {
    case 0:
      return identity;
    case 1:
      return (s) => s != null ? s[a] : void 0;
    case 2:
      return (s) => s != null ? (s = s[a]) != null ? s[b] : void 0 : void 0;
    case 3:
      return (s) => s != null ? (s = s[a]) != null ? (s = s[b]) != null ? s[c] : void 0 : void 0 : void 0;
    case 4:
      return (s) => s != null ? (s = s[a]) != null ? (s = s[b]) != null ? (s = s[c]) != null ? s[d] : void 0 : void 0 : void 0 : void 0;
    default:
      return (s) => {
        const n = ks.length - 1;
        let res = s;
        for (let i = 0; res != null && i <= n; i++) {
          res = res[ks[i]];
        }
        return res;
      };
  }
}
export {
  defGetter,
  defGetterUnsafe
};
